export default function BulkActions({ selectedItems, onAction, actions }) {
  if (selectedItems.length === 0) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-blue-800">
          {selectedItems.length} item(s) selected
        </span>
        <div className="flex gap-2">
          {actions.map(action => (
            <button
              key={action.key}
              onClick={() => onAction(action.key, selectedItems)}
              className={`px-3 py-1 rounded text-sm font-medium ${action.className || 'bg-blue-500 text-white hover:bg-blue-600'}`}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}